import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
var colors = tokens.colors;
export var tabIcon = {
  name: "eslind",
  styles: "width:12px;height:12px;margin-left:5px;"
};
export var tabLabel = {
  name: "1hgawz4",
  styles: "vertical-align:top;"
};
export var tabPressed = /*#__PURE__*/css("background-color:", colour.neutral200, ";");
export var dropDown = /*#__PURE__*/css("position:absolute;width:100%;height:236px;left:0;top:calc(100% + 6px);border:1px solid ", colors.neutral.trim.default, ";background-color:", colour.white, ";display:inline-block;border-radius:3px;");
export var dropDownItem = /*#__PURE__*/css("padding:9px 11px;cursor:pointer;color:", colour.neutral700, ";font-size:", font.baseFontSize, ";background:none;border:0;display:block;width:100%;text-align:left;outline:none;&:hover{background-color:", colour.neutral100, ";}");
export var dropDownItemLabel = {
  name: "1hgawz4",
  styles: "vertical-align:top;"
};
export var dropDownItemCheckedIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";float:right;vertical-align:middle;margin:0 12px;");